/**
 * 增强版的防重复点击指令
 * 仅针对 el-button 元素进行防重复点击，其他元素不受影响
 */
import apiCallManager from './apiCallManager.js'

const preventReClick = {
  inserted: function (el, binding) {
    // 检查是否为 el-button 元素
    const isElButton = el.classList.contains('el-button') ||
                      el.querySelector('.el-button') ||
                      el.tagName.toLowerCase() === 'button' && el.className.includes('el-button');

    if (!isElButton) {
      // 如果不是 el-button，使用基础防重复点击逻辑
      el.addEventListener('click', () => {
        if (!el.disabled) {
          el.disabled = true
          setTimeout(() => {
            el.disabled = false
          }, binding.value || 3000)
        }
      })
      return;
    }

    // 仅对 el-button 应用增强的防重复点击逻辑
    el.addEventListener('click', (event) => {
      // 如果按钮已经被禁用，直接返回
      if (el.disabled) {
        event.stopImmediatePropagation();
        event.preventDefault();
        return false;
      }

      // 禁用按钮
      el.disabled = true;

      // 添加视觉反馈
      const originalText = el.textContent || el.innerText;
      if (!originalText.includes('处理中')) {
        el.setAttribute('data-original-text', originalText);
        el.textContent = originalText + ' (处理中...)';
      }

      // 设置定时器恢复按钮状态
      const timeout = binding.value || 3000;

      const resetButton = () => {
        el.disabled = false;
        const originalText = el.getAttribute('data-original-text');
        if (originalText) {
          el.textContent = originalText;
          el.removeAttribute('data-original-text');
        }
      };

      // 监听全局API调用状态变化（仅对 el-button）
      const checkApiStatus = () => {
        const status = apiCallManager.getStatus();
        if (!status.isLocked) {
          // 如果API调用已完成，立即恢复按钮状态
          resetButton();
        } else {
          // 如果API调用仍在进行中，继续检查
          setTimeout(checkApiStatus, 100);
        }
      };

      // 启动状态检查
      setTimeout(checkApiStatus, 500);

      // 兜底：即使API状态检查失败，也要在超时后恢复按钮
      setTimeout(() => {
        if (el.disabled) {
          resetButton();
        }
      }, timeout);
    });
  }
};

export { preventReClick };



// WEBPACK FOOTER //
// ./src/assets/js/enhancedClickStatefrom.js